import { render, staticRenderFns } from "./CarAdditionalData.vue?vue&type=template&id=2b9ea6a9&scoped=true&"
import script from "./CarAdditionalData.vue?vue&type=script&lang=js&"
export * from "./CarAdditionalData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9ea6a9",
  null
  
)

export default component.exports